import { Form, Spinner } from "react-bootstrap";
import {
  clearCart,
  resetCurrentAppointment,
  successfullBooking,
} from "../../redux/cart";
import { editDoctorServiceCount, getDoctors } from "../../redux/doctors";
import { editLabServiceCount, getLabs } from "../../redux/labs";
import { getIntervalsBetweenShifts, isItToday } from "doitfast";
import {
  getLocationsOfCurrentDetailsPage,
  getProviderDetails,
} from "../../Helpers/getProviderDetails";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import BookAgainLocation from "./BookAgainLocation";
import BookAgainStatus from "./BookAgainStatus";
import BookingCardAddedServices from "../BookingCardAddedServices";
import CardBody from "./CardBody";
import CardTitle from "./CardTitle";
import Confirmation from "../SingleDoctor/services/confirmation";
import GoogleFaceBook from "../auth/GoogleFaceBook";
import LoginForm from "../auth/LoginForm";
import OrLine from "../auth/OrLine";
import SelectLocation from "./SelectLocation";
import arrangeDaysFromToday from "../../Helpers/arrangDaysFromToday";
import axios from "axios";
import { bookAgain } from "../../redux/cart";
import { getMyAppointments } from "../../redux/myappointments";
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import { CCard, CCardBody, CCardHeader } from "@coreui/react";
import { appendItem } from "../../Helpers/appendItem";
import { FaTooth } from "react-icons/fa";
import moment from "moment-timezone";
import { langContext } from "../../context/LangProvider";

export default function BookingCard({
  overLay,
  data,
  dataName,
  confirmation,
  handleConfirm,
  isShowingModal,
  myAppointment,
}) {
  const formData = [
    {
      label: "E-Mail",
      placeholder: "E-Mail Address",
      type: "email",
      name: "email",
    },
    {
      label: "Password",
      placeholder: "Password",
      type: "password",
      name: "password",
    },
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginStatus, token, user } = useSelector((state) => state.user);
  const { myAppointments } = useSelector((state) => state.myAppointments);
  const { cart, fees, feesWithNoDiscount, dataExistId, currentAppointment } =
    useSelector((state) => state.cart);
  const { doctors } = useSelector((state) => state.doctors);
  const { labs } = useSelector((state) => state.labs);
  const { id } = useParams();
  const [dataInput, setDataInput] = useState("d-none");
  const [appointmentVisibilty, setappointmentVisibilty] = useState("d-none");
  const [bookedServices, setBookedServices] = useState([]);
  const [viewdAppointments, setViewdAppointments] = useState([]);
  const [viewdDays, setViewdDays] = useState([]);
  const [notes, setNotes] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedAppointment, setSelectedAppointment] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [labAppointMent, setLabAppointMent] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [options, setOptions] = useState([]);
  const [disabledSelection, setDisabledSelection] = useState(false);
  const [sendingAppointment, setSendingAppointment] = useState(false);
  const [images, setImages] = useState([]);
  const onPictureDrop = useCallback(
    (acceptedFiles) => {
      setImages(acceptedFiles);
    },
    [images]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onPictureDrop,
  });
  const [sendingAppointmentText, setSendingAppointmentText] =
    useState("Book Appointment");
  // initial selected Day & Date
  useEffect(() => {
    setSelectedDay(
      new Date(viewdDays[0]?.date).toLocaleString("default", {
        weekday: "long",
      })
    );
    setSelectedDate(new Date(viewdDays[0]?.date).toLocaleDateString());
  }, [viewdDays]);

  useEffect(() => {
    // Getting the data depending on the current page (doctor/lab)
    let dataDetails;
    if (dataName === "doctor") {
      dataDetails = getProviderDetails(dataName, id, dataExistId, doctors);
    } else {
      dataDetails = getProviderDetails(dataName, id, dataExistId, labs);
    }

    // Getting the locations of data(doctor/lab)
    dataDetails &&
      setOptions(
        getLocationsOfCurrentDetailsPage(
          dataDetails,
          dataName,
          setappointmentVisibilty,
          setViewdDays,
          setSelectedLocation,
          setViewdAppointments
        )
      );
  }, [dataExistId, dataName, id]);

  useEffect(() => {
    setBookedServices(cart);
  }, [cart, data]);
  useEffect(() => {
    if (loginStatus) {
      setDataInput("d-none");
    }
  }, [loginStatus]);

  const handleChooseLocation = (selection) => {
    setappointmentVisibilty("");
    let sortedAppointments = arrangeDaysFromToday([
      ...selection.location.availabilities.filter(
        (availability) => availability.closed === false
      ),
    ]);
    if (sortedAppointments.length) {
      let isToday = isItToday(sortedAppointments[0].date);
      if (dataName === "lab") {
        if (
          isToday &&
          +sortedAppointments[0].close_hour.substring(0, 2) <
            new Date().getHours() + 1
        ) {
          sortedAppointments = sortedAppointments.slice(1);
        }
        isToday = false;
      }
      let viewdAppointments;
      if (sortedAppointments.length) {
        viewdAppointments = getIntervalsBetweenShifts(
          sortedAppointments[0].open_hour,
          sortedAppointments[0].close_hour,
          "00:30",
          isToday
        );
      } else {
        viewdAppointments = [];
      }
      setViewdAppointments(viewdAppointments);
      setViewdDays(sortedAppointments);
    } else {
      setViewdAppointments([]);
      setViewdDays([]);
    }
    setSelectedLocation(selection);
  };

  const appointmentHandler = (selection) => {
    if (bookedServices.length > 0) {
      overLay("");
      setappointmentVisibilty("d-none");
      setDisabledSelection(true);
      setDataInput("");

      if (dataName === "doctor") {
        setSelectedAppointment(selection);
      } else {
        const startShift = viewdAppointments.find(
          (appointment) =>
            appointment.includes("AM") && appointment === viewdAppointments[0]
        );
        const endShift = viewdAppointments.find(
          (appointment) =>
            appointment.includes("PM") &&
            appointment === viewdAppointments[viewdAppointments.length - 1]
        );
        setSelectedAppointment(startShift);
        setLabAppointMent(`${startShift} - ${endShift}`);
      }
    } else {
      toast.error("Please select at least one service");
    }
  };

  const cancel = () => {
    setDataInput("d-none");
    overLay("d-none");
    setappointmentVisibilty("");
    setSelectedAppointment("");
    setDisabledSelection(false);
  };

  const bookAgainHandler = () => {
    dispatch(bookAgain(currentAppointment));
    if (dataName === "doctor") {
      currentAppointment.services.forEach((service) => {
        dispatch(
          editDoctorServiceCount({
            dataId: data.id,
            serviceCount: parseInt(service.pivot.quantity),
            serviceId: service.id,
            doctors,
          })
        );
      });
    } else {
      currentAppointment.services.forEach((service) => {
        dispatch(
          editLabServiceCount({
            dataId: data.id,
            serviceCount: parseInt(service.pivot.quantity),
            serviceId: service.id,
            labs,
          })
        );
      });
    }

    navigate(window.location.pathname.replace("myAppointment", ""));
    dispatch(resetCurrentAppointment());
  };
  const bookAppointmentHandler = async () => {
    let selectedServices = [];
    cart.map((ele) => {
      const { doctor_id, lab_id, created_at, updated_at, ...serviceProps } =
        ele.service.pivot;
      serviceProps.quantity = ele.count;
      selectedServices.push(serviceProps);
    });
    setSendingAppointment(true);
    setSendingAppointmentText(<Spinner animation="border" size="sm" />);
    try {
      let formData = new FormData();
      let values = {
        new_gallery: images.length > 0 ? images : [""],
        user_id: user.id,
        provider_id: data?.id,
        provider_type: dataName,
        fees,
        patient_notes: notes,
        services: selectedServices,
        location_id: selectedLocation.id,
        time: `${selectedDay} , ${selectedDate} , ${selectedAppointment}`,
        timezone: moment.tz.guess(),
      };

      Object.keys(values).forEach((key) => {
        appendItem(formData, key, values[key]);
      });
      let res = await axios.post(
        `${process.env.REACT_APP_URL}/book_an_appointment`,
        formData,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      console.log(res);
      if (res.data.success) toast.success("Appointment created successfully");
      let dataDetails;
      if (dataName === "doctor") {
        dataDetails = getProviderDetails(dataName, id, dataExistId, doctors);
      } else {
        dataDetails = getProviderDetails(dataName, id, dataExistId, labs);
      }
      dispatch(
        successfullBooking({
          fees,
          feesWithNoDiscount,
          data,
          dataName,
          waiting_time: data?.waiting_time,
          phone: dataName === "lab" ? dataDetails.phone : "",
          workingHours: labAppointMent,
          date: `${selectedDay} , ${selectedDate} , ${selectedAppointment}`,
          locations:
            dataDetails.locations.length > 1 ? options : [selectedLocation],
        })
      );
      dispatch(clearCart());
      dispatch(getDoctors()); // to reset services count
      dispatch(getLabs()); // to reset services count
      dispatch(getMyAppointments()); // to update myAppointments
      navigate("/success");
    } catch (err) {
      console.log(err);
    } finally {
      setSendingAppointment(false);
      setSendingAppointmentText("Book Appointment");
    }
  };
  const { t } = useContext(langContext);
  return (
    <div className="booking-card">
      <CardTitle dataName={dataName} isShowingModal={isShowingModal} />
      {!confirmation ? (
        <>
          <BookingCardAddedServices
            bookedServices={bookedServices}
            fees={fees}
            feesWithNoDiscount={feesWithNoDiscount}
            myAppointment={myAppointment}
          />

          {myAppointment && (
            <BookAgainStatus currentAppointment={currentAppointment} />
          )}
          <div className="booking-item d-flex align-items-center">
            {myAppointment ? (
              <BookAgainLocation
                options={options}
                currentAppointment={currentAppointment}
              />
            ) : (
              <SelectLocation
                options={options}
                handleChooseLocation={handleChooseLocation}
                disabledSelection={disabledSelection}
              />
            )}
          </div>
          <div className="booking-item ">
            {myAppointment ? (
              <div style={{ direction: "rtl" }}>
                <>
                  <img
                    src="/assets/edit-inactive.svg"
                    alt=""
                    className="mx-2 icon-img-size"
                  />
                  <span className="me-1">{t("Doctor Note :")}</span>
                  <span className="bold">
                    {currentAppointment?.provider_notes?.text}
                  </span>
                </>

                {currentAppointment?.provider_notes?.teeth && (
                  <div className="m-2">
                    <FaTooth size={20} />
                    <span className="mx-1">{t("Teeth notes :")}</span>
                    {currentAppointment?.provider_notes?.teeth.map(
                      (tooth, index) => {
                        return (
                          <div className="mx-5 d-flex flex-column">
                            <span className="me-1 ">
                              {index + 1} <span>{t("- Tooth :")}</span>
                              <span className="bold">{tooth.value}</span>
                            </span>
                            <span className="me-1 mx-4">
                              {t("Note :")}{" "}
                              <span className="bold">{tooth.note}</span>
                            </span>
                          </div>
                        );
                      }
                    )}
                  </div>
                )}
                <div>
                  <div className="">
                    <img
                      src="/assets/edit-inactive.svg"
                      alt=""
                      className="mx-2 icon-img-size"
                    />
                    <span className="me-1">{t("Patient notes :")} </span>
                  </div>
                  <span className="bold">
                    {currentAppointment?.patient_notes}
                  </span>
                  {currentAppointment?.gallery?.length > 0 && (
                    <div>
                      <span className="bold">{t("Image(s) :")}</span>
                      <div
                        className="d-flex flex-row w-100"
                        style={{ overflowX: "scroll" }}
                      >
                        {currentAppointment.gallery.map((image) => {
                          return (
                            <img
                              onClick={() => {
                                window.open(
                                  image.original_url,
                                  "_blank",
                                  "noopener,noreferrer"
                                );
                              }}
                              src={image.original_url}
                              style={{
                                cursor: "pointer",
                                width: "200px",
                                height: "200px",
                                display: "flex",
                              }}
                              className="m-2 icon-img-size border rounded"
                            />
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <>
                <img
                  src="/assets/booking.svg"
                  alt=""
                  className="mx-2 icon-img-size"
                />
                <span className="me-1">{t("Selected Appointment :")}</span>
                {selectedAppointment !== "" && dataName === "doctor" ? (
                  <span className="bold">{`${selectedDay} , ${selectedDate} , ${selectedAppointment}`}</span>
                ) : (
                  selectedAppointment !== "" &&
                  dataName === "lab" && (
                    <span className="bold">{`${selectedDay} , ${selectedDate} , ${labAppointMent}`}</span>
                  )
                )}
              </>
            )}
          </div>
          <div className="booking-item ">
            <img
              src="/assets/waiting-time.svg"
              alt=""
              className="mx-2 icon-img-size"
            />
            <span className="me-1">
              {dataName === "doctor"
                ? t("Waiting Time: ")
                : t("Working Hours ")}
            </span>
            {dataName === "doctor" && (
              <span className="bold">{data?.waiting_time}</span>
            )}
          </div>
          {myAppointment && (
            <div className="booking-item">
              <div className="d-flex justify-content-center">
                <button className="mb-3 w-60 pop-up" onClick={bookAgainHandler}>
                  {t("Book Again")}
                </button>
              </div>
            </div>
          )}
          {!myAppointment && (
            <div
              className={`booking-item no-bottom-border slidz ${appointmentVisibilty}`}
            >
              <CardBody
                dataName={dataName}
                viewdAppointments={viewdAppointments}
                viewdDays={viewdDays}
                setSelectedDay={setSelectedDay}
                setViewdAppointments={setViewdAppointments}
                setSelectedDate={setSelectedDate}
                appointmentHandler={appointmentHandler}
                isShowingModal={isShowingModal}
                data={data}
                confirmation={confirmation}
                handleConfirm={handleConfirm}
              />
            </div>
          )}
          {loginStatus && bookedServices.length ? (
            <div className={`${dataInput} p-3`}>
              <Form.Control
                as="textarea"
                rows="5"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Write Your Notes here (optional)"
              />

              <div className="d-flex justify-content-center my-2">
                <CCard>
                  <CCardHeader>{t("Submit images")}</CCardHeader>
                  <CCardBody>
                    <div
                      {...getRootProps()}
                      className="p-4 bg-light border border-dark border-dashed"
                    >
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p className="m-0 text-center">
                          {t("Drop files here")}
                        </p>
                      ) : (
                        <p className="m-0 text-center">
                          {t("Drag file or click to upload file")}
                        </p>
                      )}
                    </div>
                    {images?.map((image) => {
                      return (
                        <img
                          className="m-2"
                          height="50"
                          src={
                            image instanceof File
                              ? URL.createObjectURL(image)
                              : typeof image === "string"
                              ? image
                              : image
                          }
                          alt="item"
                        />
                      );
                    })}
                  </CCardBody>
                </CCard>
              </div>
              <div className="mail-phone">
                <button
                  className="mb-3 w-60 pop-up"
                  onClick={bookAppointmentHandler}
                  disabled={sendingAppointment}
                >
                  {sendingAppointmentText}
                </button>
                <button className="mb-3 w-30" type="button" onClick={cancel}>
                  {t("Cancel")}
                </button>
              </div>
            </div>
          ) : (
            <div className={`booking-item no-bottom-border ${dataInput}`}>
              <GoogleFaceBook />
              <div>
                <OrLine />
                <LoginForm
                  formData={formData}
                  formPadding="bookingFormPadding"
                  formWidth="bookingFormWidth"
                  dataName={dataName}
                />
              </div>
            </div>
          )}
        </>
      ) : (
        <Confirmation handleConfirm={handleConfirm} />
      )}
    </div>
  );
}
